<template>
  <div>

    <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">首页</div>

    <div style="background-color: #eee;overflow-y: auto;" :style="th">

      <div style="padding: 10px;">

        <div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">签约老人</div>
              <div style="">{{this.elderlyCheckin}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">男/女(已入住)</div>
              <div style="">{{this.elderlyCheckinMan}}/{{this.elderlyCheckinWoman}}({{this.elderlyCheckinTrue}})</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">医生总数</div>
              <div style="">{{this.medCount}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">护士总数</div>
              <div style="">{{this.nurseCount}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">护工总数</div>
              <div style="">{{this.nurseAideCount}}</div>
            </div>
          </div>

          <div style="clear: both;"></div>
        </div>

        <div style="height: 10px;"></div>

        <div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">余额预警</div>
              <div style="">{{this.lessBalanceWaitCount}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">设备总数</div>
              <div style="">{{this.deviceCount}}</div>
            </div>
          </div>

          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">总余额</div>
              <div style="">{{this.totalBalance}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">总预交金</div>
              <div style="">{{this.totalAdvance}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">总备用金</div>
              <div style="">{{this.totalImprest}}</div>
            </div>
          </div>

          <div style="clear: both;"></div>
        </div>

        <div style="height: 10px;"></div>

        <div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">日扣款统计</div>
                <ve-line :data="chartData_total_day" :settings="chartSettings_total_day"></ve-line>
              </div>

            </div>
          </div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">月扣款统计</div>
                <ve-histogram :data="chartData_total_month" :settings="chartSettings_total_month"></ve-histogram>
              </div>

            </div>
          </div>
          <div style="clear: both;"></div>
        </div>

        <div style="height: 10px;"></div>




      </div>

    </div>


  </div>

</template>



<script>


import {timeStr} from "@/common/times";
import {getStaffCode, getStaffDTO} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Home",

  components:{

  },
  data: function () {
    return {

      th:'',


      chartSettings_total_day:{
        labelMap:{
          day:"日期",
          money:"扣款",
        }
      },
      chartData_total_day: {
        columns: ['day', 'money'],
        rows: [
          {'day':'1','money':'200'},
          {'day':'2','money':'150'},

        ]
      },

      chartSettings_total_month:{
        labelMap:{
          month:"月份",
          count:"订单数",
          money:"销售额",
        }
      },
      chartData_total_month: {
        columns: ['month','money'],
        rows: [
          {'month':'1','money':'2000'},
          {'month':'2','money':'1350'},
        ]
      },


      chartSettings_elderly:{
        //设置中文图例
        labelMap:{
          //date对应后台返回json数据的key，具体值根据接口字段来修改
          age:"年龄",
          //total对应后台返回son数据的value，具体值根据接口字段来修改
          man:"男",
          woman:'女',
        }
      },
      chartData_elderly: {
        //这里的格式必须是对应上面后台接口的字段才能显示图例
        columns: ['age', 'man','woman'],
        rows: [
          {'age':'60-65','man':'20','woman':'22'},
          {'age':'66-70','man':'14','woman':'17'},
          {'age':'71-75','man':'10','woman':'12'},
          {'age':'76-80','man':'8','woman':'7'},
          {'age':'81-120','man':'7','woman':'4'},
        ]
      },

      chartSettings_goods:{
        //设置中文图例
        labelMap:{
          //date对应后台返回json数据的key，具体值根据接口字段来修改
          class:"项目分类",
          //total对应后台返回son数据的value，具体值根据接口字段来修改
          total:"销售占比"
        }
      },
      chartData_goods: {
        //这里的格式必须是对应上面后台接口的字段才能显示图例
        columns: ['class', 'total'],
        rows: [
          {'class':'家政','total':'203'},
          {'class':'助餐','total':'143'},
          {'class':'护理','total':'93'},
          {'class':'康复','total':'60'},
          {'class':'精神慰藉','total':'35'},
          {'class':'智能设备','total':'22'},
        ]
      },



      elderlyCheckin:0,
      elderlyCheckinTrue:0,
      elderlyCheckinMan:0,
      elderlyCheckinWoman:0,

      medCount:0,
      nurseCount:0,
      nurseAideCount:0,

      alarmRecordCount:0,
      alarmRecordCountWait:0,

      lessBalanceWaitCount:0,
      deviceCount:0,

      totalBalance:0,
      totalAdvance:0,
      totalImprest:0,


    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = "height:"+(val+140-25)+"px";
    },
  },
  created(){
    this.th = "height:"+(this.$store.state.tableHeight+140-25)+"px";

    this.getElderlyCount();

    this.getMedicinerCount();

    this.getNurseCount();

    this.getNurseAideCount();

    this.getLessBalanceWaitCount();

    this.getDeviceCount();

    this.getTotalOrder();

    this.getTotalMoneyAll();

  },
  methods:{

    getElderlyCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Elderly/PannelIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.elderlyCheckin = response.data.data.elderlyCheckin;
              this.elderlyCheckinTrue = response.data.data.elderlyCheckinTrue;
              this.elderlyCheckinMan = response.data.data.elderlyCheckinMan;
              this.elderlyCheckinWoman = response.data.data.elderlyCheckinWoman;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },

    getMedicinerCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Mediciner/PannelIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.medCount = response.data.data.medCount;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },

    getNurseCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Nurse/PannelIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.nurseCount = response.data.data.nurseCount;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },

    getNurseAideCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NurseAide/PannelIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.nurseAideCount = response.data.data.nurseAideCount;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },

    getLessBalanceWaitCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"LessBalance/Count",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.lessBalanceWaitCount = response.data.data.countWait;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },

    getDeviceCount(){
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"GroupDevice/PannelIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          institutionCode: getStaffDTO().institutionDTO.institutionCode,
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.deviceCount = response.data.data.deviceCount;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


    getTotalOrder(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Total/PannelIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then((response) => {
        if (response.data.error == 0) {

          let listTotalOrderDay = response.data.data.listTotalLessDay;
          let arr = [];
          for(let i=0;i<listTotalOrderDay.length;i++){
            arr.push({"day":listTotalOrderDay[i].day,"money":listTotalOrderDay[i].lessBalance});
          }
          this.chartData_total_day.rows = arr;

          let listTotalOrderMonth = response.data.data.listTotalLessMonth;
          let arr2 = [];
          for(let i=0;i<listTotalOrderMonth.length;i++){
            arr2.push({"month":listTotalOrderMonth[i].month,"money":listTotalOrderMonth[i].lessBalance});
          }
          this.chartData_total_month.rows = arr2;



        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })

    },


    getTotalMoneyAll(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ElderlyFund/TotalInsMoney",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then((response) => {
        if (response.data.error == 0) {

          this.totalBalance = response.data.data.totalBalance;
          this.totalAdvance = response.data.data.totalAdvance;
          this.totalImprest = response.data.data.totalImprest;

        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })

    },


  }

}


</script>

